'use strict';

angular.module('atex.dam').factory('DamStatusService', ['$q', 'ContentService',
  function ($q, ContentService) {

    var statusList;
    var webStatusList;
    var attributesList;

    return {
      getStatusList: function () {
        if (statusList === undefined) {
          var transferInfo = {id: 'atex.WFStatusList'};
          statusList = ContentService.getContent(transferInfo).then(function (response) {
            var list = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
            return angular.copy(list);
          });
        }
        return statusList;
      },
      getWebStatusList: function () {
        if (webStatusList === undefined) {
          var transferInfo = {id: 'atex.WebStatusList'}; 
          webStatusList = ContentService.getContent(transferInfo).then(function (response) {
            var list = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/status');
            return angular.copy(list);
          });
        }
        return webStatusList;
      },
      getAttributesList: function () {
        if (attributesList === undefined) {
          var transferInfo = {id: 'atex.WFStatusAttributeList'};
          attributesList = ContentService.getContent(transferInfo).then(function (response) {
            var list = atex.onecms.ObjectUtils.getByPath(response, 'data/aspects/contentData/data/attributes');
            return angular.copy(list);
          });
        }
        return attributesList;
      },
      getStatusById: function(statusList, statusID) {
        var getter = this.getStatusList;
        if (statusList === 'atex.WebStatusList') {
          getter = this.getWebStatusList;
        }
        return getter().then(function(statusList){
          return statusList.find(function(status) {
            return status.statusID === statusID;
          });
        });
      }
    };
  }
]);
